import type {
  FieldType,
  FormFieldType,
  SchemaField,
  WalkFieldsOptions
} from '@cli-types/core-engine/schema.js'

export const FIELD_TYPES = {
  STRING: 'string',
  EMAIL: 'email',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  TEXT: 'text',
  DECIMAL: 'decimal',
  VARCHAR: 'varchar',
  UUID: 'uuid',
  SERIAL: 'serial',
  DATE: 'date',
  TIMESTAMP: 'timestamp',
  TIME: 'time',
  MARKDOWN: 'markdown',
  RICHTEXT: 'richtext',
  IMAGE: 'image',
  VIDEO: 'video',
  MEDIA: 'media',
  ICON: 'icon',
  GROUP: 'group',
  TABS: 'tabs',
  LIST: 'list',
  SEPARATOR: 'separator',
  SECTION: 'section',
  SELECT: 'select',
  RELATIONSHIP: 'relationship',
  GALLERY: 'gallery'
} as const
export const LAYOUT_FIELD_TYPES = [FIELD_TYPES.SEPARATOR] as const
export const COLUMN_TYPES = {
  TEXT: 'text',
  BADGE: 'badge',
  DATE: 'date',
  CUSTOM: 'custom',
  AVATAR: 'avatar',
  LINK: 'link',
  IMAGE: 'image',
  EMAIL: 'email',
  NUMBER: 'number',
  BOOLEAN: 'boolean'
} as const
export const FORM_FIELD_TYPES = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  EMAIL: 'email',
  PHONE: 'phone',
  NUMBER: 'number',
  URL: 'url',
  DATE: 'date',
  SELECT: 'select',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  MULTISELECT: 'multiselect',
  FILE: 'file',
  UPLOAD: 'upload',
  GROUP: 'group',
  TIMEZONE: 'timezone',
  LIST: 'list',
  DYNAMIC_FIELDS: 'dynamicFields'
} as const
export const AUTO_FIELDS = {
  ID: 'id',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  PUBLISHED: 'published',
  SLUG: 'slug'
} as const
export const FORM_SUBMISSION_FIELDS = {
  SUBMITTED_AT: 'submittedAt',
  IP_ADDRESS: 'ipAddress',
  USER_AGENT: 'userAgent'
} as const
export const DRIZZLE_DEFAULTS = {
  VARCHAR_LENGTH: 255,
  DECIMAL_PRECISION: 10,
  DECIMAL_SCALE: 2
} as const
export const ENTITY_SINGLE_ADD_FIELD_TYPES = [
  'string',
  'email',
  'varchar',
  'text',
  'markdown',
  'richtext',
  'number',
  'decimal',
  'boolean',
  'date',
  'timestamp',
  'time',
  'image',
  'video',
  'media',
  'gallery',
  'icon',
  'select',
  'relationship',
  'list',
  'group',
  'section',
  'tabs',
  'separator'
] as const satisfies readonly FieldType[]
export const FORM_ADD_FIELD_TYPES = [
  'text',
  'textarea',
  'email',
  'phone',
  'number',
  'url',
  'date',
  'select',
  'radio',
  'checkbox',
  'file'
] as const satisfies readonly FormFieldType[]
export const FORM_OPTION_FIELD_TYPES = ['select', 'radio', 'checkbox'] as const
export const FORM_OPTION_FIELD_TYPE_SET = new Set<string>(FORM_OPTION_FIELD_TYPES)
export const FORM_REQUIRED_OPTION_FIELD_TYPES = new Set<string>(['select', 'radio'])
export const NON_INTERACTIVE_CONTAINER_TYPES = new Set(['group', 'section', 'tabs', 'list'])
export const SYSTEM_FIELD_NAMES = new Set([
  'id',
  'uuid',
  'serial',
  'slug',
  'createdAt',
  'updatedAt',
  'published',
  'submittedAt',
  'ipAddress',
  'userAgent',
  'createdBy',
  'updatedBy',
  'createdByUser',
  'updatedByUser'
])
export const SCHEMA_LAYOUT_TYPES = new Set(['group', 'section', 'tabs', 'separator'])
export const FORM_LAYOUT_TYPES = new Set(['group'])
export const RESERVED_AUTHORSHIP_FIELD_NAMES = new Set([
  'createdBy',
  'updatedBy',
  'createdByUser',
  'updatedByUser'
])
export const FORM_COLUMN_TYPES = new Set(['text', 'date', 'email', 'number', 'badge'])
export const GENERATED_SCHEMA_TITLE_FIELD_NAME = 'title'
export const ENTITY_SLUG_FIELD_NAME = 'slug'
export const ENTITY_SLUG_FIELD_TYPES = new Set(['string', 'varchar', 'text'])
export const GENERATED_SCHEMA_TITLE_FIELD_TYPES = new Set(['string', 'varchar', 'text'])
export const FORM_SCHEMA_TITLE_FIELD_TYPES = new Set(['text'])
export const FORM_SUBMISSION_COLUMN_NAMES = [
  AUTO_FIELDS.ID,
  FORM_SUBMISSION_FIELDS.SUBMITTED_AT,
  FORM_SUBMISSION_FIELDS.IP_ADDRESS,
  FORM_SUBMISSION_FIELDS.USER_AGENT,
  AUTO_FIELDS.CREATED_AT,
  AUTO_FIELDS.UPDATED_AT
] as const
export const USER_RELATIONSHIP_TARGET = 'users'
export const AUTO_ID_FIELD: SchemaField = {
  name: 'id',
  type: 'uuid',
  primaryKey: true
}
export const DEFAULT_WALK_OPTIONS: WalkFieldsOptions = {
  includeLists: true,
  includeGroups: true,
  includeTabs: true
}
